// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"95305d74","777":"e9eb4a19"}[chunkId] + ".js";
};